import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles.scss';

const HomeFiltersSection = ({ children }) => <div className={styles.section}>{children}</div>;

HomeFiltersSection.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HomeFiltersSection;
